import { useIsItemVariationAvailable } from 'src/modules/checkout/composables/sales-availability/items/IsItemVariationAvailable'
import { computed, toValue } from 'vue'

// Options is a hash containing fields that can be used to validate item variation availability.
const DEFAULT_OPTIONS = Object.freeze({
  salesChannel: null,
  orderItem: null
})

// itemVariations and options are optional, assuming the caller may intend to use computeAvailableItemVariations directly
export function useAvailableItemVariations (itemVariations = [], options = DEFAULT_OPTIONS) {
  const { isItemVariationAvailable } = useIsItemVariationAvailable()

  function computeAvailableItemVariations (itemVariations, { salesChannel, orderItem } = DEFAULT_OPTIONS) {
    return _(toValue(itemVariations))
      .filter(itemVariation => isItemVariationAvailable(itemVariation, { salesChannel, orderItem }))
      .sortBy('displayOrder')
      .value()
  }

  // We wrap itemVariations with computed to ensure reactivity
  // useAvailableItemVariations may be called with a null model, which wouldn't be reactive
  // e.g. props?.category?.itemVariations?.data before category is set
  // This would prevent availableItemVariations from reacting to changes in itemVariations
  // If itemVariations is set or already reactive, this is a safe no-op
  // This ensures useAvailableItemVariations is resilient without complicated usage requirements
  const availableItemVariations = computed(() => computeAvailableItemVariations(computed(() => itemVariations), options))

  return {
    computeAvailableItemVariations,
    availableItemVariations
  }
}
